import { render, staticRenderFns } from "./SubscriberNotificationsLogModal.vue?vue&type=template&id=b5cfc690&scoped=true&"
import script from "./SubscriberNotificationsLogModal.vue?vue&type=script&lang=js&"
export * from "./SubscriberNotificationsLogModal.vue?vue&type=script&lang=js&"
import style0 from "./SubscriberNotificationsLogModal.vue?vue&type=style&index=0&id=b5cfc690&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5cfc690",
  null
  
)

export default component.exports